// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .scroll-area[data-v-502e4822]{max-height:calc(100vh - 104px);overflow:auto}@media only screen and (min-width:600px){.hrsata-jobs .scroll-area[data-v-502e4822]{height:calc(100vh - 320px);max-height:calc(100vh - 320px)}}", ""]);
// Exports
module.exports = exports;
